import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import { GET_USERS_PATH, GetUsersQueryParams, GetUsersSuccessDto, User } from '@/api/rest/resources/types/user';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

export const useUsers = (organizationIdArg?: string) => {
  const orgId = useOrganizationId();

  const organizationId = organizationIdArg ?? orgId;

  const queryParams: GetUsersQueryParams = {
    organization: organizationId,
  };
  const queryFn = async () => {
    return (await getRequest<GetUsersSuccessDto>(GET_USERS_PATH, undefined, queryParams)).results;
  };

  return useSuspenseQuery<User[], Error>({
    queryKey: ['user', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
